<h1>Terms & Conditions</h1>
<p>
  Lorem ipsum dolor sit amet consectetur adipisicing elit. Saepe harum quia
  tempore dolore obcaecati, expedita ratione. Modi, nihil! Temporibus
  perferendis minima eaque iure consequuntur eligendi repellendus hic earum eius
  nam?
</p>
<h2>Some Heading</h2>
<p>
  Lorem ipsum dolor sit amet consectetur adipisicing elit. Saepe harum quia
  tempore dolore obcaecati, expedita ratione. Modi, nihil! Temporibus
  perferendis minima eaque iure consequuntur eligendi repellendus hic earum eius
  nam?
</p>
<h2>Another Heading</h2>
<p>
  Lorem ipsum dolor sit amet consectetur adipisicing elit. Saepe harum quia
  tempore dolore obcaecati, expedita ratione. Modi, nihil! Temporibus
  perferendis minima eaque iure consequuntur eligendi repellendus hic earum eius
  nam?
</p>
